import type { LatestProject } from '../types/latestProjects';

/*
 * Latest Projects widget data. Optional fields left empty are hidden in the interface.
 * To add a real photograph, set imageUrl (and add approved shots to gallery).
 */
export const latestProjects: LatestProject[] = [
  {
    id: 'a3-francistown-kutamogoree',
    title: 'A3 Francistown–Nata Road Reconstruction',
    category: 'roads',
    location: 'Francistown–Kutamogoree section, Botswana',
    client: 'Ministry of Transport and Infrastructure',
    clientApproved: true,
    developmentManager: 'Okavango Africa Consortium',
    contractArrangement: 'UNIK / LIFTOFF joint venture for the listed section',
    relationshipNote:
      'Liftoff Investments works on the Francistown–Kutamogoree section through the UNIK / LIFTOFF joint venture. It is not the contractor for the whole Francistown–Nata programme.',
    status: 'ongoing',
    scope:
      'Roadbed construction and subbase and base materials for a 20 km section from Marapong to Kutamogoree, including relocation of 6 km of water pipelines and borehole equipping.',
    expectedCompletion: 'May 2027',
    values: [
      { label: 'Overall programme value', amount: 'P1.8 billion' },
      { label: 'Liftoff section value', amount: 'P221 million' },
    ],
    valueApproved: false,
    imageAlt: 'A3 Francistown–Kutamogoree road section',
    gallery: [],
    enquiryService: 'roadworks',
    publication: 'published',
    featured: true,
    verificationNotes: [
      'Confirm the project is still ongoing before publication.',
      'Expected completion (May 2027) is as recorded in the 2026 work-experience document.',
      'Programme value (P1.8 billion) and section value (P221 million) are hidden until publication is approved.',
      'Add approved photographs from the A3 road banner.',
    ],
  },
  {
    id: 'goodhope-vacuum-sewer',
    title: 'Goodhope Vacuum Sewer Infrastructure Refurbishment',
    category: 'water',
    location: 'Goodhope, Botswana',
    client: 'Water Utilities Corporation (WUC)',
    clientApproved: true,
    status: 'pending',
    scope:
      'Refurbishment of vacuum sewer infrastructure, including three vacuum sewer pump stations, pumps, 65 km of sewer reticulation pipeline, a lift station, 250 vacuum sewer chambers, electrical works and telemetry.',
    recordedCompletion: 'April 2026',
    values: [{ label: 'Recorded project value', amount: 'P15.4 million' }],
    valueApproved: false,
    imageAlt: 'Goodhope vacuum sewer pump station',
    gallery: [],
    enquiryService: 'water',
    publication: 'published',
    featured: true,
    verificationNotes: [
      'The recorded completion date (April 2026) has passed. Set the status to Ongoing or Completed once confirmed.',
      'Project value (P15.4 million) is hidden until publication is approved.',
      'Add approved photographs from the Goodhope vacuum sewer banner.',
    ],
  },
  {
    id: 'khoemacau-boxcut-slope',
    title: 'Boxcut Slope Maintenance — Sand and Vegetation Removal',
    category: 'mining',
    location: 'Khoemacau Copper Mine, Botswana',
    client: 'Khoemacau Copper Mine',
    clientApproved: false,
    status: 'ongoing',
    scope:
      'Two-year contract for sand removal and vegetation clearing from boxcut slopes. Activities include clearing, loading, transporting and disposing of material in accordance with site requirements.',
    contractPeriod: 'Two years',
    valueApproved: false,
    imageAlt: 'Boxcut slopes at Khoemacau Copper Mine',
    gallery: [],
    enquiryService: 'civil',
    publication: 'published',
    featured: true,
    verificationNotes: [
      'Confirm the project is still ongoing.',
      'Client name is hidden until Khoemacau Copper Mine approves being named.',
      'Add an approved photograph from the KHOEMACAU PULLUP document.',
    ],
  },
];
